"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IDL = void 0;
exports.IDL = {
    "version": "0.0.0",
    "name": "zeta_flex",
    "instructions": [
        {
            "name": "initializeState",
            "accounts": [
                {
                    "name": "state",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "systemProgram",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "admin",
                    "isMut": true,
                    "isSigner": true
                },
                {
                    "name": "mintAuthority",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "vaultAuthority",
                    "isMut": false,
                    "isSigner": false
                }
            ],
            "args": [
                {
                    "name": "args",
                    "type": {
                        "defined": "InitializeStateArgs"
                    }
                }
            ]
        },
        {
            "name": "initializeUnderlying",
            "accounts": [
                {
                    "name": "state",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "underlying",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "mint",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "oracle",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "admin",
                    "isMut": true,
                    "isSigner": true
                },
                {
                    "name": "systemProgram",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "tokenProgram",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "rent",
                    "isMut": false,
                    "isSigner": false
                }
            ],
            "args": [
                {
                    "name": "args",
                    "type": {
                        "defined": "InitializeUnderlyingArgs"
                    }
                }
            ]
        },
        {
            "name": "initializeOption",
            "accounts": [
                {
                    "name": "state",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "underlying",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "vault",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "vaultAuthority",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "collateralMint",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "collateralTokenAccount",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "creator",
                    "isMut": true,
                    "isSigner": true
                },
                {
                    "name": "optionAccount",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "mintAuthority",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "optionMint",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "userOptionTokenAccount",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "systemProgram",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "tokenProgram",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "rent",
                    "isMut": false,
                    "isSigner": false
                }
            ],
            "args": [
                {
                    "name": "args",
                    "type": {
                        "defined": "InitializeOptionArgs"
                    }
                }
            ]
        },
        {
            "name": "burnOption",
            "accounts": [
                {
                    "name": "state",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "vault",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "collateralMint",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "collateralTokenAccount",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "creator",
                    "isMut": true,
                    "isSigner": true
                },
                {
                    "name": "optionAccount",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "mintAuthority",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "optionMint",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "userOptionTokenAccount",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "tokenProgram",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "vaultAuthority",
                    "isMut": false,
                    "isSigner": false
                }
            ],
            "args": [
                {
                    "name": "amount",
                    "type": "u64"
                }
            ]
        },
        {
            "name": "expireOptionOverride",
            "accounts": [
                {
                    "name": "state",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "underlying",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "collateralMint",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "optionAccount",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "optionMint",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "vault",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "admin",
                    "isMut": false,
                    "isSigner": true
                }
            ],
            "args": [
                {
                    "name": "overridePrice",
                    "type": "u64"
                }
            ]
        },
        {
            "name": "expireOption",
            "accounts": [
                {
                    "name": "state",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "underlying",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "collateralMint",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "optionAccount",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "oracle",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "optionMint",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "vault",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "creator",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "vaultAuthority",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "tokenProgram",
                    "isMut": false,
                    "isSigner": false
                }
            ],
            "args": []
        },
        {
            "name": "exerciseOption",
            "accounts": [
                {
                    "name": "state",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "vault",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "collateralMint",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "collateralTokenAccount",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "authority",
                    "isMut": true,
                    "isSigner": true
                },
                {
                    "name": "optionAccount",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "optionMint",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "userOptionTokenAccount",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "tokenProgram",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "vaultAuthority",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "creator",
                    "isMut": true,
                    "isSigner": false
                }
            ],
            "args": []
        },
        {
            "name": "collectRemainingCollateral",
            "accounts": [
                {
                    "name": "state",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "vault",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "collateralTokenAccount",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "creator",
                    "isMut": true,
                    "isSigner": true
                },
                {
                    "name": "optionAccount",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "optionMint",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "userOptionTokenAccount",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "tokenProgram",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "vaultAuthority",
                    "isMut": false,
                    "isSigner": false
                }
            ],
            "args": []
        },
        {
            "name": "initializeAuction",
            "accounts": [
                {
                    "name": "state",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "auctionAccount",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "creator",
                    "isMut": true,
                    "isSigner": true
                },
                {
                    "name": "vaultAuthority",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "auctionVault",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "auctionTokenMint",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "creatorAuctionTokenAccount",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "creatorBidCurrencyTokenAccount",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "bidCurrencyMint",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "systemProgram",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "tokenProgram",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "rent",
                    "isMut": false,
                    "isSigner": false
                }
            ],
            "args": [
                {
                    "name": "args",
                    "type": {
                        "defined": "InitializeAuctionArgs"
                    }
                }
            ]
        },
        {
            "name": "cancelAuction",
            "accounts": [
                {
                    "name": "state",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "auctionAccount",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "creator",
                    "isMut": true,
                    "isSigner": true
                },
                {
                    "name": "vaultAuthority",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "auctionVault",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "auctionTokenMint",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "creatorAuctionTokenAccount",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "creatorBidCurrencyTokenAccount",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "tokenProgram",
                    "isMut": false,
                    "isSigner": false
                }
            ],
            "args": []
        },
        {
            "name": "bidAuction",
            "accounts": [
                {
                    "name": "state",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "auctionAccount",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "bidder",
                    "isMut": true,
                    "isSigner": true
                },
                {
                    "name": "bidAccount",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "vaultAuthority",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "bidVault",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "bidCurrencyMint",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "bidderBidCurrencyTokenAccount",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "bidderAuctionTokenAccount",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "systemProgram",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "tokenProgram",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "rent",
                    "isMut": false,
                    "isSigner": false
                }
            ],
            "args": [
                {
                    "name": "args",
                    "type": {
                        "defined": "BidAuctionArgs"
                    }
                }
            ]
        },
        {
            "name": "cancelBid",
            "accounts": [
                {
                    "name": "state",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "auctionAccount",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "bidder",
                    "isMut": true,
                    "isSigner": true
                },
                {
                    "name": "bidAccount",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "vaultAuthority",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "bidVault",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "bidderBidCurrencyTokenAccount",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "tokenProgram",
                    "isMut": false,
                    "isSigner": false
                }
            ],
            "args": []
        },
        {
            "name": "acceptBid",
            "accounts": [
                {
                    "name": "state",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "auctionAccount",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "bidder",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "creator",
                    "isMut": true,
                    "isSigner": true
                },
                {
                    "name": "bidAccount",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "vaultAuthority",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "bidVault",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "auctionVault",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "bidderAuctionTokenAccount",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "creatorBidCurrencyTokenAccount",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "tokenProgram",
                    "isMut": false,
                    "isSigner": false
                }
            ],
            "args": [
                {
                    "name": "expectedAmount",
                    "type": "u64"
                }
            ]
        }
    ],
    "accounts": [
        {
            "name": "optionAccount",
            "type": {
                "kind": "struct",
                "fields": [
                    {
                        "name": "version",
                        "type": {
                            "defined": "Version"
                        }
                    },
                    {
                        "name": "oracleMethod",
                        "type": {
                            "defined": "OracleMethod"
                        }
                    },
                    {
                        "name": "optionAccountNonce",
                        "type": "u8"
                    },
                    {
                        "name": "optionMintNonce",
                        "type": "u8"
                    },
                    {
                        "name": "creatorOptionTokenAccountNonce",
                        "type": "u8"
                    },
                    {
                        "name": "vaultNonce",
                        "type": "u8"
                    },
                    {
                        "name": "underlyingCount",
                        "type": "u64"
                    },
                    {
                        "name": "optionMint",
                        "type": "publicKey"
                    },
                    {
                        "name": "underlyingMint",
                        "type": "publicKey"
                    },
                    {
                        "name": "collateralMint",
                        "type": "publicKey"
                    },
                    {
                        "name": "exerciseMint",
                        "type": "publicKey"
                    },
                    {
                        "name": "creator",
                        "type": "publicKey"
                    },
                    {
                        "name": "collateralAmount",
                        "type": "u64"
                    },
                    {
                        "name": "creatorExerciseMintTokenAccount",
                        "type": "publicKey"
                    },
                    {
                        "name": "strike",
                        "type": "u64"
                    },
                    {
                        "name": "expiry",
                        "type": {
                            "defined": "Expiry"
                        }
                    },
                    {
                        "name": "kind",
                        "type": {
                            "defined": "Kind"
                        }
                    },
                    {
                        "name": "settlementType",
                        "type": {
                            "defined": "SettlementType"
                        }
                    },
                    {
                        "name": "settlementPrice",
                        "type": "u64"
                    },
                    {
                        "name": "profitPerOption",
                        "type": "u64"
                    },
                    {
                        "name": "remainingCollateral",
                        "type": "u64"
                    }
                ]
            }
        },
        {
            "name": "underlying",
            "type": {
                "kind": "struct",
                "fields": [
                    {
                        "name": "underlyingNonce",
                        "type": "u8"
                    },
                    {
                        "name": "mint",
                        "type": "publicKey"
                    },
                    {
                        "name": "oracle",
                        "type": "publicKey"
                    },
                    {
                        "name": "count",
                        "type": "u64"
                    }
                ]
            }
        },
        {
            "name": "state",
            "type": {
                "kind": "struct",
                "fields": [
                    {
                        "name": "stateNonce",
                        "type": "u8"
                    },
                    {
                        "name": "mintAuthNonce",
                        "type": "u8"
                    },
                    {
                        "name": "vaultAuthNonce",
                        "type": "u8"
                    },
                    {
                        "name": "admin",
                        "type": "publicKey"
                    },
                    {
                        "name": "settlementPriceThresholdSeconds",
                        "type": "u32"
                    },
                    {
                        "name": "padding",
                        "type": {
                            "array": [
                                "u64",
                                32
                            ]
                        }
                    }
                ]
            }
        },
        {
            "name": "auctionAccount",
            "type": {
                "kind": "struct",
                "fields": [
                    {
                        "name": "auctionNonce",
                        "type": "u8"
                    },
                    {
                        "name": "auctionVaultNonce",
                        "type": "u8"
                    },
                    {
                        "name": "creator",
                        "type": "publicKey"
                    },
                    {
                        "name": "creatorBidCurrencyTokenAccount",
                        "type": "publicKey"
                    },
                    {
                        "name": "amount",
                        "type": "u64"
                    },
                    {
                        "name": "bidEnd",
                        "type": "u64"
                    },
                    {
                        "name": "cooldownEnd",
                        "type": "u64"
                    },
                    {
                        "name": "auctionTokenMint",
                        "type": "publicKey"
                    },
                    {
                        "name": "bidCurrencyMint",
                        "type": "publicKey"
                    },
                    {
                        "name": "exchangeAmount",
                        "type": "u64"
                    },
                    {
                        "name": "winningBidder",
                        "type": "publicKey"
                    }
                ]
            }
        },
        {
            "name": "bidAccount",
            "type": {
                "kind": "struct",
                "fields": [
                    {
                        "name": "bidAccountNonce",
                        "type": "u8"
                    },
                    {
                        "name": "bidVaultNonce",
                        "type": "u8"
                    },
                    {
                        "name": "bidder",
                        "type": "publicKey"
                    },
                    {
                        "name": "amount",
                        "type": "u64"
                    },
                    {
                        "name": "bidEnd",
                        "type": "u64"
                    },
                    {
                        "name": "cooldownEnd",
                        "type": "u64"
                    },
                    {
                        "name": "auctionAccount",
                        "type": "publicKey"
                    },
                    {
                        "name": "bidVault",
                        "type": "publicKey"
                    },
                    {
                        "name": "bidderAuctionTokenAccount",
                        "type": "publicKey"
                    }
                ]
            }
        }
    ],
    "types": [
        {
            "name": "Expiry",
            "type": {
                "kind": "struct",
                "fields": [
                    {
                        "name": "settlementStart",
                        "type": "u64"
                    },
                    {
                        "name": "settlementEnd",
                        "type": "u64"
                    }
                ]
            }
        },
        {
            "name": "InitializeOptionArgs",
            "type": {
                "kind": "struct",
                "fields": [
                    {
                        "name": "collateralAmount",
                        "type": "u64"
                    },
                    {
                        "name": "optionAccountNonce",
                        "type": "u8"
                    },
                    {
                        "name": "optionMintNonce",
                        "type": "u8"
                    },
                    {
                        "name": "tokenAccountNonce",
                        "type": "u8"
                    },
                    {
                        "name": "vaultNonce",
                        "type": "u8"
                    },
                    {
                        "name": "settlementStart",
                        "type": "u64"
                    },
                    {
                        "name": "settlementEnd",
                        "type": "u64"
                    },
                    {
                        "name": "strike",
                        "type": "u64"
                    },
                    {
                        "name": "kind",
                        "type": {
                            "defined": "Kind"
                        }
                    },
                    {
                        "name": "settlementType",
                        "type": {
                            "defined": "SettlementType"
                        }
                    }
                ]
            }
        },
        {
            "name": "InitializeAuctionArgs",
            "type": {
                "kind": "struct",
                "fields": [
                    {
                        "name": "auctionNonce",
                        "type": "u8"
                    },
                    {
                        "name": "auctionVaultNonce",
                        "type": "u8"
                    },
                    {
                        "name": "amount",
                        "type": "u64"
                    },
                    {
                        "name": "bidEnd",
                        "type": "u64"
                    },
                    {
                        "name": "cooldownEnd",
                        "type": "u64"
                    }
                ]
            }
        },
        {
            "name": "BidAuctionArgs",
            "type": {
                "kind": "struct",
                "fields": [
                    {
                        "name": "bidAccountNonce",
                        "type": "u8"
                    },
                    {
                        "name": "bidVaultNonce",
                        "type": "u8"
                    },
                    {
                        "name": "amount",
                        "type": "u64"
                    }
                ]
            }
        },
        {
            "name": "InitializeStateArgs",
            "type": {
                "kind": "struct",
                "fields": [
                    {
                        "name": "stateNonce",
                        "type": "u8"
                    },
                    {
                        "name": "mintAuthNonce",
                        "type": "u8"
                    },
                    {
                        "name": "vaultAuthNonce",
                        "type": "u8"
                    },
                    {
                        "name": "settlementPriceThresholdSeconds",
                        "type": "u32"
                    }
                ]
            }
        },
        {
            "name": "InitializeUnderlyingArgs",
            "type": {
                "kind": "struct",
                "fields": [
                    {
                        "name": "underlyingNonce",
                        "type": "u8"
                    }
                ]
            }
        },
        {
            "name": "Version",
            "type": {
                "kind": "enum",
                "variants": [
                    {
                        "name": "V0"
                    }
                ]
            }
        },
        {
            "name": "OracleMethod",
            "type": {
                "kind": "enum",
                "variants": [
                    {
                        "name": "SpotPrint"
                    }
                ]
            }
        },
        {
            "name": "Kind",
            "type": {
                "kind": "enum",
                "variants": [
                    {
                        "name": "Undefined"
                    },
                    {
                        "name": "Call"
                    },
                    {
                        "name": "Put"
                    }
                ]
            }
        },
        {
            "name": "SettlementType",
            "type": {
                "kind": "enum",
                "variants": [
                    {
                        "name": "Undefined"
                    },
                    {
                        "name": "Cash"
                    }
                ]
            }
        }
    ],
    "errors": [
        {
            "code": 300,
            "name": "UnauthorizedAdmin",
            "msg": "Unauthorized admin"
        },
        {
            "code": 301,
            "name": "TokenAccountMintMismatch",
            "msg": "Token account mint mismatch"
        },
        {
            "code": 302,
            "name": "InvalidTokenAccountOwner",
            "msg": "Invalid token account owner"
        },
        {
            "code": 303,
            "name": "InsufficientFunds",
            "msg": "Insufficient funds"
        },
        {
            "code": 304,
            "name": "InsufficientOptionsToBurn",
            "msg": "Insufficient options to burn"
        },
        {
            "code": 305,
            "name": "OnlyCreatorCanCloseOptionAccount",
            "msg": "Only creator can close option account"
        },
        {
            "code": 306,
            "name": "OnlyCreatorCanBurnOptions",
            "msg": "Only creator can burn options"
        },
        {
            "code": 307,
            "name": "OptionExpirationMustBeInTheFuture",
            "msg": "Option expiration must be in the future"
        },
        {
            "code": 308,
            "name": "OptionHasNotExpiredYet",
            "msg": "Option has not expired yet"
        },
        {
            "code": 309,
            "name": "OnlyAdminCanOverrideSettlementPrice",
            "msg": "Only admin can override settlement price"
        },
        {
            "code": 310,
            "name": "BeforeSetSettlementPriceTime",
            "msg": "Before set settlement price time"
        },
        {
            "code": 311,
            "name": "AfterSetSettlementPriceTime",
            "msg": "After set settlement price time"
        },
        {
            "code": 312,
            "name": "SettlementPriceAlreadySet",
            "msg": "Settlement price already set"
        },
        {
            "code": 313,
            "name": "SettlementPriceNotSet",
            "msg": "SettlementPriceNotSet"
        },
        {
            "code": 314,
            "name": "InvalidOracle",
            "msg": "InvalidOracle"
        },
        {
            "code": 315,
            "name": "InvalidSettlementOptionMint",
            "msg": "Invalid settlment option mint"
        },
        {
            "code": 316,
            "name": "CannotBurnOptionsAfterExpiry",
            "msg": "Cannot burn options after expiry"
        },
        {
            "code": 317,
            "name": "CannotBurnOptionsAfterSettlementPriceIsSet",
            "msg": "Cannot burn options after settlement price is set"
        },
        {
            "code": 318,
            "name": "OwnerMismatch",
            "msg": "Owner mismatch"
        },
        {
            "code": 319,
            "name": "OptionMintMismatch",
            "msg": "Option mint mismatch"
        },
        {
            "code": 320,
            "name": "AuctionCooldownEndHasToBeAfterBidEnd",
            "msg": "Auction cooldown end has to be after bid end"
        },
        {
            "code": 321,
            "name": "AuctionBidEndHasToBeInTheFuture",
            "msg": "Auction bid end has to be in the future"
        },
        {
            "code": 322,
            "name": "OnlyCreatorCanCancelAuction",
            "msg": "Only creator can cancel auction"
        },
        {
            "code": 323,
            "name": "CannotCancelAuctionAfterCompletion",
            "msg": "Cannot cancel auction after completion"
        },
        {
            "code": 324,
            "name": "CannotBidAfterBidEnd",
            "msg": "Cannot bid after bid end"
        },
        {
            "code": 325,
            "name": "OnlyBidderCanCancelBid",
            "msg": "Only bidder can cancel bid"
        },
        {
            "code": 326,
            "name": "BidCurrencyMintMismatch",
            "msg": "BidCurrencyMintMismatch"
        },
        {
            "code": 327,
            "name": "CannotCancelBidDuringCooldownPeriod",
            "msg": "Cannot cancel bid during cooldown period"
        },
        {
            "code": 328,
            "name": "ExpectedAmountMismatch",
            "msg": "ExpectedAmountMismatch"
        },
        {
            "code": 329,
            "name": "CannotAcceptBidOutsideOfCooldownPeriod",
            "msg": "Cannot accept bid outside of cooldown period"
        },
        {
            "code": 330,
            "name": "InvalidBidderAuctionTokenAccount",
            "msg": "Invalid bidder auction token account"
        },
        {
            "code": 331,
            "name": "InvalidCreatorBidCurrencyTokenAccount",
            "msg": "Invalid creator bid currency token account"
        },
        {
            "code": 332,
            "name": "CreatorNativeTokenAccountShouldBeEmpty",
            "msg": "Creator native token account should be empty"
        },
        {
            "code": 333,
            "name": "NativeTokenAuctionUnsupported",
            "msg": "Native token auction unsupported"
        },
        {
            "code": 334,
            "name": "CancelBidNativeTokenAccountShouldBeEmpty",
            "msg": "Cancel bid native token account should be empty"
        },
        {
            "code": 335,
            "name": "CollateralAmountNotAFactorOfMinLotSize",
            "msg": "Collateral amount not a factor of min lot size"
        },
        {
            "code": 336,
            "name": "CannotInitializeOptionWithZeroCollateral",
            "msg": "Cannot initialize option with zero collateral"
        },
        {
            "code": 337,
            "name": "CannotInitializeAuctionWithZeroAmount",
            "msg": "Cannot initialize auction with zero amount"
        },
        {
            "code": 338,
            "name": "InvalidOptionKind",
            "msg": "Invalid option kind"
        },
        {
            "code": 339,
            "name": "CallCollateralMintMustMatchUnderlyingMint",
            "msg": "Call collateral mint must match underlying mint"
        },
        {
            "code": 340,
            "name": "InvalidUsdMint",
            "msg": "Invalid usd mint"
        },
        {
            "code": 341,
            "name": "InvalidUnderlyingMint",
            "msg": "Invalid underlying mint"
        },
        {
            "code": 342,
            "name": "InvalidCollateralMint",
            "msg": "Invalid collateral mint"
        },
        {
            "code": 343,
            "name": "InvalidCreator",
            "msg": "Invalid creator"
        }
    ]
};
